import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app';
import ErrorBoundary from './components/error-boundary';
import { applyInitialTheme } from './components/theme-toggle';
import { installAutoUpdate } from './utils/auto-update';

// Apply the stored/system theme before first paint to avoid a flash.
applyInitialTheme();
// Reload long-lived tabs / home-screen PWAs onto a freshly-deployed build when they're refocused.
installAutoUpdate();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Tell the boot watchdog (index.html) the module graph loaded and React started.
window.__appBooted?.();
